import * as React from 'react';
import cx from 'classnames';
import styles from './Checkbox.css';
// TODO: Need to make this component take style and default props
// TODO: Label position also needs to be configurable
export default class Checkbox extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleCheckboxClick = (e) => {
            e && e.preventDefault && e.preventDefault();
            if (this.props.disabled) {
                if (typeof this.props.onChangeDisable === 'function') {
                    this.props.onChangeDisable();
                }
                return;
            }
            this.setState({
                checked: !this.state.checked
            }, () => {
                if (this.props.onChange && typeof this.props.onChange === 'function') {
                    this.props.onChange({ checked: this.state.checked });
                }
            });
        };
        this.handleActualRendering = () => {
            this.setState({ actualRendered: true });
        };
        this.state = {
            checked: props.checked || false,
            actualRendered: !props.optimize
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if ('checked' in nextProps &&
            typeof nextProps.checked !== 'undefined' &&
            nextProps.checked !== this.state.checked) {
            this.setState({
                checked: nextProps.checked
            });
        }
    }
    render() {
        const checkboxClass = cx(styles['checkbox'], {
            [styles['lazy-rendered']]: !this.state.actualRendered && !this.state.checked,
            [styles['disabled']]: this.props.disabled,
            [styles['large']]: this.props.large
        }, this.props.className);
        if (!this.state.actualRendered && !this.state.checked) {
            return (<div className={checkboxClass} onMouseOver={this.handleActualRendering}>
					{this.props.label}
				</div>);
        }
        // As per react's expectation, we should pass an onChange
        // handler to an input field, or else pass readOnly prop to
        // signal that this field is not mutable explicitly. Since we
        // attach an onClick event to the label rather than the input
        // field directly, we should be passing readOnly
        //
        // https://github.com/facebook/react/blob/b61174fb7b09580c1ec2a8f55e73204b706d2935/packages/react-dom/src/shared/ReactControlledValuePropTypes.js
        return (<label className={checkboxClass} onClick={this.handleCheckboxClick}>
				<input type="checkbox" checked={this.state.checked} className={styles['control']} readOnly/>
				<div className={cx(styles['control-indicator'], this.props.iconClass, {
            [styles['partial']]: this.props.partial
        })}/>
				{this.props.label ? (<div className={cx(styles['labelctn'], this.props.labelClass)}>{this.props.label}</div>) : null}
			</label>);
    }
}
